import React, {Component, Fragment} from 'react'
import {connect} from "react-redux";
import {showGrouped, showInverters, showNoSamil, showPeriod, clear} from "../actions/filters";
import {Button, DatePicker, Tag} from 'antd';
import {itemsFetchMonth} from "../actions/monthitems";
import * as APP_CONFIG from "../constants/config";
import moment from 'moment';
const {DBDatePattern,DBDateFormat} = APP_CONFIG;

class FilterNav extends Component {

    showGrouped = () => {
        this.props.dispatch(showGrouped(!this.props.filters.showGrouped));
        this.props.dispatch(itemsFetchMonth());
    }
    showNoSamil = () => {
        this.props.dispatch(showNoSamil(!this.props.filters.showNoSamil));
    }
    showInverters = () => {
        this.props.dispatch(showInverters(!this.props.filters.showInverters));
        this.props.dispatch(itemsFetchMonth());
    }
    showPeriod = (period) => {
        this.props.dispatch(showPeriod(period));
        this.props.dispatch(itemsFetchMonth());
    }
    reset = () => {
        this.props.dispatch(clear());
        this.props.dispatch(itemsFetchMonth());
    }
    onDateChange = (date, dateString) => {
        if(DBDatePattern.test(dateString) && moment().diff(moment(dateString)) > 0){ // een valide datum voor morgen
            if(dateString === moment().format(DBDateFormat)) // selectie vandaag
                dateString = 'today';
            this.props.dispatch(showPeriod(dateString));
            this.props.dispatch(itemsFetchMonth());
        }
    }

    render() {

        const {showGrouped, showNoSamil, showInverters, showPeriod} = this.props.filters;
        const labelGroupItems = showGrouped ? 'Ongegroepeerd' : 'Gegroepeerd';
        //const labelNoSamil = showNoSamil ? 'Alle locaties' : 'Geen Samil';
        const labelInverters = showInverters ? 'Locaties' : 'Omvormers';
        const showReset = showNoSamil || showGrouped  || showInverters || showPeriod!=='yesterday';
        const filterString = <Fragment>
            Filters:
            <Tag style={{marginLeft: '6px'}}>{showInverters?'omvormers':'locaties'}</Tag>
            <Tag>{showPeriod==='yesterday'?'gisteren':showPeriod==='today'?
                'vandaag':showPeriod==='week'?'week':showPeriod}</Tag>
            {showGrouped ? <Tag>gegroepeerd op plaats</Tag> : ''}
        </Fragment>;
        const datePickerDate = showPeriod === 'today' ? moment() : showPeriod === 'yesterday' ?
            moment().add(-1, 'days') : showPeriod === 'week' ? null : moment(showPeriod);
        return (
            <div>
                <div>
                    {/*<a className="link" onClick={this.showNoSamil}>{labelNoSamil}</a>*/}
                    {/*<a className="link" onClick={this.showInverters}>{labelInverters}</a>*/}
                    <Button.Group>
                        <Button onClick={this.showInverters}>{labelInverters}</Button>
                        <Button onClick={this.showGrouped}>{labelGroupItems}</Button>
                    </Button.Group>
                    <DatePicker style={{margin:'6px', top: '1px'}} value={datePickerDate} showToday={false} placeholder="Kies datum" size="Small" onChange={this.onDateChange} />

                    <Button.Group>
                        {showPeriod==='today' ? '' : <Button onClick={() => this.showPeriod('today')}>Bekijk vandaag</Button>}
                        {showPeriod==='yesterday' ? '' : <Button onClick={() => this.showPeriod('yesterday')}>Bekijk gisteren</Button>}
                        {showPeriod==='week' ? '' : <Button onClick={() => this.showPeriod('week')}>Bekijk week</Button>}
                    </Button.Group>
                    <Button onClick={this.reset} style={{marginLeft: '6px', display:showReset?'':'none'}}>Reset</Button>

                </div>
                <div style={{marginTop: '10px',marginBottom: '4px'}}>{filterString} </div>
            </div>
        );
    }
}

let mapStateToProps = state => ({
    filters: state.filters
});

export default connect(mapStateToProps)(FilterNav);



// WEBPACK FOOTER //
// ./src/components/FilterNav.js